import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=457aff63&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457aff63",
  null
  
)

export default component.exports